import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "vectorvault",
  title: "Vector Vault",
  description:
    "Search, preview, edit, upload, and export SVG icons from a local vector library.",
  category: "Design",
} satisfies ToolMeta;
